export default "__VITE_ASSET__DwtueIY4__"